import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { changeCashierURLServiceToService } from '@corefront/redux-aba';
import { useDeeplinkProtocol } from './useDeeplinkRedirect';
import { SERVICE_NAME } from '../constants';

export const useChangeCashierResultURL = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const protocol = useDeeplinkProtocol();

  useEffect(() => {
    const serviceToServiceRedirect = {
      path: pathname,
      'service-name': SERVICE_NAME,
    };

    dispatch(
      changeCashierURLServiceToService({
        to: serviceToServiceRedirect,
        protocol,
      })
    );
  }, [dispatch, protocol, pathname]);
};
